/**
 * Quick-buy popup for the PDP "different forms" carousel (snippets/product-forms.liquid).
 *
 * Clicking a card reveals the matching pre-rendered panel; nothing navigates. The panels
 * hold real Shopify product forms, so add-to-cart and Buy Now are handled by the theme's
 * existing product-form.js / product-custom.js - this file only shows, hides and traps
 * focus.
 */
(function () {
  var OPEN_CLASS = 'forms-modal--open';
  var BODY_CLASS = 'forms-modal-open';
  // :not([tabindex="-1"]) on the anchor too - keeps the aria-hidden image link out of the Tab cycle.
  var FOCUSABLE =
    'a[href]:not([tabindex="-1"]), button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init(modal) {
    if (modal.dataset.formsModalReady === 'true') return;
    modal.dataset.formsModalReady = 'true';

    // A theme-editor section reload renders a fresh copy while the one we already moved to
    // <body> is still there, so drop the stale twin before claiming the id.
    document.querySelectorAll('body > [data-forms-modal]').forEach(function (stale) {
      if (stale !== modal && stale.id === modal.id) stale.remove();
    });

    // The PDP info column sits inside transformed / sticky ancestors, which would make a
    // position:fixed overlay resolve against them instead of the viewport. Reparenting to
    // <body> keeps listeners intact (they are bound to the nodes, not the position).
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    var dialog = modal.querySelector('.forms-modal__dialog');
    var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-forms-panel]'));
    var lastFocused = null;

    function showPanel(id) {
      var match = null;
      panels.forEach(function (panel) {
        var isMatch = panel.getAttribute('data-forms-panel') === id;
        panel.hidden = !isMatch;
        if (isMatch) match = panel;
      });
      return match;
    }

    function open(id, trigger) {
      var panel = showPanel(id);
      if (!panel) return false;

      lastFocused = trigger || document.activeElement;

      var title = panel.querySelector('.forms-modal__title');
      if (title && title.id) {
        dialog.setAttribute('aria-labelledby', title.id);
      } else {
        dialog.removeAttribute('aria-labelledby');
      }

      modal.hidden = false;
      // Next frame so the transition has a from-state to animate out of.
      requestAnimationFrame(function () {
        modal.classList.add(OPEN_CLASS);
      });
      document.body.classList.add(BODY_CLASS);

      var target = panel.querySelector(FOCUSABLE) || dialog;
      target.focus({ preventScroll: true });
      return true;
    }

    function close() {
      if (modal.hidden) return;
      modal.classList.remove(OPEN_CLASS);
      modal.hidden = true;
      document.body.classList.remove(BODY_CLASS);
      panels.forEach(function (panel) {
        panel.hidden = true;
      });
      if (lastFocused && document.contains(lastFocused)) lastFocused.focus({ preventScroll: true });
      lastFocused = null;
    }

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-forms-close]')) close();
    });

    // Click-outside. Bound on the document rather than the backdrop so it holds however
    // the overlay happens to be laid out: anything that is not inside the card closes.
    // The [data-forms-open] check matters - the click that opened the popup keeps
    // bubbling up to here, and without it the popup would shut again immediately.
    document.addEventListener('click', function (event) {
      if (modal.hidden) return;
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('.forms-modal__dialog')) return;
      if (target.closest('[data-forms-open]')) return;
      close();
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = Array.prototype.slice
        .call(dialog.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null;
        });
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Both buttons hand off to the cart drawer / cross-sell popup, so step out of the way
    // as soon as one is used rather than stacking two overlays.
    // Bubble phase on purpose: product-form.js listens on the form itself, so letting it
    // run first means it reads the form (and its FormData) while still visible.
    modal.addEventListener('submit', function (event) {
      if (event.target.closest('.forms-modal__form')) close();
    });
    modal.addEventListener('click', function (event) {
      if (event.target.closest('.forms-modal__buy-now')) close();
    });

    // Cards live in the section, not in the modal, so they are wired from here.
    var section = document.getElementById(modal.id.replace('FormsModal-', 'Slider-ProductForms-'));
    var scope = (section && section.closest('.product-forms')) || document;
    scope.querySelectorAll('[data-forms-open]').forEach(function (card) {
      if (card.dataset.formsOpenReady === 'true') return;
      card.dataset.formsOpenReady = 'true';
      card.addEventListener('click', function () {
        open(card.getAttribute('data-forms-open'), card);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-forms-modal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders the section without re-running deferred scripts.
  document.addEventListener('shopify:section:load', initAll);
})();
